import React, { useState } from 'react';

import Toggle, { ToggleNew } from '../../Buttons/Toggle';
import { Block } from '../../../../../components';
import { SeparationLine } from '../../../modules/scholarships/bse/forms/family/styled';

interface ToggleCardProps {
  children?: any;
  widthProps?: any;
  isMigrated?: any;
  isPayment?: boolean;
}

const ToggleCard = ({
  children,
  widthProps,
  isMigrated,
  isPayment
}: ToggleCardProps) => {
  const [toggleOpen, setToggleOpen] = useState(false);

  return (
    <Block
      customized
      maxWidth={widthProps}
      backgroundColor="#fff"
      borderRadius="8px"
      margin={isPayment ? '0px' : '0px 0px 32px 0px'}
      display="block"
      justifyContent="center"
      alignItems="center"
      transition="all 1s ease"
      shadow="0px 2px 8px -4px rgba(176, 192, 202, 0.2)"
      height="auto"
      overflow="hidden"
    >
      {/* <BlockStyled> */}
      <Block customized padding="12px 12px 0px 12px">
        <Block
          customized
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {children[0]}
          {isMigrated && (
            <Toggle
              itStartsOpened={toggleOpen}
              onClick={() => {
                setToggleOpen(!toggleOpen);
              }}
            />
          )}
        </Block>
      </Block>

      <Block customized padding="8px 12px 8px 12px">
        {children[1]}
      </Block>

      {!isMigrated && (
        <Block customized padding="0px 12px 8px 12px">
          <ToggleNew
            itStartsOpened={toggleOpen}
            onClick={() => {
              setToggleOpen(!toggleOpen);
            }}
          />
        </Block>
      )}
      {toggleOpen && (
        <>
          {!isMigrated && <SeparationLine style={{ margin: 0, height: 1 }} />}
          <Block customized maxWidth="100%" padding="12px" borderRadius="8px">
            {children[2]}
          </Block>
        </>
      )}
    </Block>
  );
};

export { ToggleCard };
